<script>
import { FormModel } from '@/components/global/form';
import { scrollToError } from '../../utilities/helpers';

// Step 5

export default {
    name: 'CcTurnoverForm',

    props: {
        initialData: null,
    },

    data() {
        return {
            loading: false,
            model: null,
            otherFeature: false,
        };
    },

    created() {
        this.model = new FormModel(this.initialData);
        this.otherFeature = Boolean(this.model.$.feature_other);
    },

    watch: {
        otherFeature(value) {
            if (!this.model) {
                return;
            }

            if (!value) {
                this.model.feature_other = '';
            }
        },

        'model.$.create_union_payment_account'(value) {
            if (!this.model) {
                return;
            }

            if (!value) {
                this.model.$.create_union_account = 0;
            }
        },
    },

    methods: {
        async submit() {
            if (this.loading) {
                return;
            }
            this.loading = true;

            try {
                const response = await this.$http.post('', Object.assign({ use_feature_other: Number(this.otherFeature) }, this.model.$));
                window.location = response.data.data.redirect;
            } catch (e) {
                this.model.$e.updateFromResponse(e);
                scrollToError();
                this.$sentyReporting.report(e);
            }

            this.loading = false;
        },
    },
};
</script>
